// constants shared across various components

export const DIALOG_HIDE_CLASS = 'bk-dialog--hidden';
